import React, { Component } from 'react'
import { connect } from 'react-redux'
import ArticleList from 'components/page/ArticleList'
import { actions } from './redux'
import preload from 'components/enhancer/preload'
import composeHOC from 'shared/utils/composeHOC'
import Meta from 'components/layout/Meta';

class LoanInfoList extends Component {

  constructor(props) {
    super(props)
    this.state = {}
  }
  componentDidMount(){

  }

  setPage(page) {
    let locations=window.location && window.location.host.split('.')    
    if((locations && !/^(ztx2|ztx1|127|localhost)$/.test(locations[0])) || !locations){//ztx2|ztx1|127分别uat,sit,本地

      window.location.href="https://info.chinatopcredit.com/aboutUs/loaninfo/list-"+page+".html"
      //this.props.router.push('/aboutUs/news/'+page)
     }else{
      this.props.router.push('/aboutUs/loaninfo/list-'+page+".html")
    }
  }

  render() {

    const {
      getLoanInfoList,
      setPage,
      children
    } = this.props

    return (
      <div>
        <Meta location={this.props.location} title="借款资讯-关于我们"/>
        { this.props.loanInfoList && <ArticleList
          title="借款资讯"
          setPage={this.setPage.bind(this)}
          subtitle="BORROWING INFORMATION"
          linkPrefix="/aboutUs/loaninfodetail/"
          pagination={this.props.loanInfoPagination}
          items={this.props.loanInfoList}
         />}
      </div>
    )
  }
}



export default composeHOC(
  connect(state => ({
    loanInfoList: state.aboutUs.loanInfoList,
    loanInfoPagination: state.aboutUs.loanInfoPagination
  }), actions),
  preload(({dispatch, location}) => {
    //const newsId = location.pathname.substr( location.pathname.lastIndexOf('/') + 1 )
    const newsId = location.pathname.substr( location.pathname.lastIndexOf('/') + 1 ).split('.')[0].split('-')[1]   
    return Promise.all([
      dispatch(actions.getLoanInfoList(newsId))
    ])
  })
)(LoanInfoList)



// WEBPACK FOOTER //
// ./modules/aboutUs/LoanInfoList.js